<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <base-material-card>
          <template v-slot:heading>
            <div
              class="display-2 font-weight-light"
            >{{id ? ('Edit Ticket - ' + ticket.ticketNo): 'Create Ticket'}}</div>

            <!-- <div class="subtitle-1 font-weight-light">
              Complete your profile
            </div>-->
          </template>

          <v-form id="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="6">
                  <v-select :items="kinds" :label="$i18n.t('Kind')" dense v-model="ticket.kind"></v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select
                    :items="subKinds"
                    :label="$i18n.t('Sub Kind')"
                    dense
                    v-model="ticket.subKind"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select
                    :items="priorities"
                    :label="$i18n.t('Priority')"
                    dense
                    v-model="ticket.priority"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="6" v-if="id">
                  <v-select
                    :items="statuses"
                    :label="$i18n.t('Status')"
                    dense
                    v-model="ticket.status"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="12">
                  <v-text-field
                    class="purple-input"
                    :label="$i18n.t('Subject')"
                    required
                    v-model="ticket.header"
                  />
                </v-col>

                <div class="subtitle-1 font-weight-light">Comments</div>
                <v-col cols="12" v-for="message in ticket.comments" :key="message.at">
                  <span>{{message.msg}}</span>
                  <br />
                  <span
                    style="float:right"
                    class="text-right"
                  >{{message.commentBy}} {{message.at | moment("DD-MMM-YY hh:mm a")}}</span>
                  <br />
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    class="purple-input"
                    :label="$i18n.t('Add new note')"
                    required
                    v-model="message"
                    value
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <v-file-input
                    chips
                    multiple
                    :label="$i18n.t('Attachments')"
                    @change="handleFileUpload()"
                    v-model="file"
                  ></v-file-input>
                </v-col>

                <v-col cols="12" class="text-right">
                  <v-btn color="info" class="mr-0" v-on:click="save()" :loading="loading">
                    <h3>{{$i18n.t('Save')}}</h3>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <div
              class="subtitle-1 font-weight-light"
              v-if="ticket.attachments && ticket.attachments.length >0"
            >Attachments</div>
            <v-simple-table>
              <tbody>
                <tr v-for="ath in ticket.attachments" :key="ath.time">
                  <td>
                    <a :href="ath.url">{{ ath.name }}</a>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPostForm } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  ticket = { ticketNo: "" };
  message = "";
  file = null;
  id = null;

  kinds = [
    {
      text: "For Web",
      value: 10,
      children: [
        {
          text: "Enhancement",
          value: 11,
        },
        {
          text: "Bug",
          value: 12,
        },
        {
          text: "Data Correction",
          value: 13,
        },
        {
          text: "New Master(Country/State/City/VehicleType)",
          value: 14,
        },
      ],
    },
    {
      text: "For App",
      value: 20,
      children: [
        {
          text: "Enhancement",
          value: 21,
        },
        {
          text: "Bug",
          value: 22,
        },
      ],
    },
  ];

  subKinds = [
    {
      text: "Enhancement",
      value: 11,
    },
    {
      text: "Bug",
      value: 12,
    },
    {
      text: "Data Correction",
      value: 13,
    },
    {
      text: "New Master(Country/State/City/VehicleType)",
      value: 14,
    },
    {
      text: "Enhancement",
      value: 21,
    },
    {
      text: "Bug",
      value: 22,
    },
  ];

  priorities = [
    {
      text: "Low",
      value: 1,
    },
    {
      text: "Medium",
      value: 2,
    },
    {
      text: "High",
      value: 3,
    },
    {
      text: "Critical",
      value: 4,
    },
  ];

  statuses = [
    {
      text: "Open",
      value: 0,
    },
    {
      text: "In Progress",
      value: 1,
    },
    {
      text: "Closed",
      value: 2,
    },
    {
      text: "Rejected",
      value: 3,
    },
    {
      text: "Client Input Required",
      value: 4,
    },
  ];

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      common.setLoading(true);
      const formData = new FormData();
      formData.set("comment", this.message);
      if (this.id) {
        formData.set("_id", this.id);
      }
      formData.set("kind", this.ticket.kind);
      formData.set("subKind", this.ticket.subKind);
      formData.set("priority", this.ticket.priority);
      formData.set("header", this.ticket.header);
      formData.set("status", this.ticket.status);

      if (this.file && this.file.length > 0) {
        formData.append("file", this.file[0]);
      }
      this.ticket = await doPostForm("/api/ticket/save/return", formData);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.ticket = await doGet("/api/ticket/" + id + "/detail");
      this.id = this.ticket._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }

  handleFileUpload(files) {
    if (files) {
      this.file = files[0];
    }
  }
}
</script>
